import { Markup } from 'interweave';
import styled, { Box } from '@xstyled/styled-components';
import { apolloClient, apolloClientSSR } from 'graphql/apollo-client';
import { CATEGORIES, STATIC_PAGE } from 'graphql/queries';
import { footerItems } from 'global/data';
import parseHTML from 'utils/parseHTML';
import SEO from '@/SEO';
import Layout from '@/UI/Layout';
import { Container } from '@/UI/Layout/Container';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';


const PageContainer = styled.div`
  h2,
  p,
  a,
  b,
  span {
    font-size: small;

    @media (max-width: desktop) {
      font-size: xsmall;
    }
  }

  h2 {
    line-height: 2;
    max-width: 1200px;
  }

  p {
    line-height: 1.75;
    margin-bottom: 2rem;
  }

  span {
    font-weight: 300;
  }

  a {
    font-weight: 500;
    text-decoration: underline;
  }

  @media (max-width: desktop) {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

export default function InfoPage({ title, content, categories }) {
  return (
    <Layout categories={categories}>
      <SEO
        seo={{
          title: `${title} - Baltbaby`
        }}
      />
      <Container mb={160}>
        <PageContainer>
          <Box
            as="h1"
            fontSize={{ _: 'large', desktop: 'xxxlarge' }}
            m="1rem 0 3rem"
          >
            {title}
          </Box>
          <Markup content={content} blockList={['div']} noWrap />
        </PageContainer>
      </Container>
    </Layout>
  );
}

export async function getStaticProps(context) {
  const query = (query, variables) => {
    return apolloClientSSR(context.locale ? context.locale : 'et').query({
      query,
      variables,
      context: {
        fetchOptions: { method: 'GET' }
      }
    });
  };

  const pagePromise = query(STATIC_PAGE, { identifier: context.params?.page });
  const categoriesPromise = query(CATEGORIES, { ids: '2' });

  try {
 const d = await categoriesPromise
  }
  catch(err) {
    console.log(err)
  }


  const [pageContent, categories] = await Promise.all([
    pagePromise,
    categoriesPromise
  ]);
  const page = pageContent?.data?.cmsPage;
  const title = page?.title;
  const content = parseHTML(page?.content);
  return {
    props: {
      title,
      content,
      categories: categories.data.categoryList
        ? categories.data.categoryList[0].children
        : [],
      ...(await serverSideTranslations(context.locale))
    },
    revalidate: 3600 // 1 hour
  };
}
export async function getStaticPaths(context) {
  const paths = footerItems.et.content.slice(0, -1).map(item => ({
    params: { page: item.path },
    locale: 'et'
  }));
  footerItems.en.content.slice(0, -1).forEach(item => {
    paths.push({ params: { page: item.path }, locale: 'en' });
  });
  return { paths, fallback: false };
}